import React from 'react'
import { useTranslation } from 'react-i18next'
import { TreatmentUpsellDetails } from '@customTypes/TreatmentUpsellDetails'
import { Advantages } from './Advantages'
import useStyles from './styles'
import { TreatmentTiles } from './TreatmentTiles'

interface Props {
  upsellDetails: TreatmentUpsellDetails
}

export const Body = ({ upsellDetails }: Props) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { explanatoryKey, advantageTranslationKeys, disclaimerTranslationKey, advantageHeadlineTranslationKey } =
    upsellDetails

  return (
    <div className={classes.body}>
      {explanatoryKey && <div className={classes.bodyHeadline}>{t(explanatoryKey)}</div>}
      <TreatmentTiles upsellDetails={upsellDetails} />
      <Advantages
        advantageTranslationKeys={advantageTranslationKeys}
        disclaimerTranslationKey={disclaimerTranslationKey}
        advantageHeadlineTranslationKey={advantageHeadlineTranslationKey}
      />
    </div>
  )
}
